import type { PermissionSetEntity } from './permissionSetEntities'

/** `allowed` must be in `pairs` order; a short list throws, since false would read as a real denial. */
export const zipRecordPermissions = <Key extends string>(
  entity: PermissionSetEntity,
  pairs: readonly (readonly [Key, string])[],
  none: Readonly<Record<Key, boolean>>,
  allowed: readonly boolean[]
): Record<Key, boolean> => {
  if (allowed.length !== pairs.length) {
    throw new Error(`Expected ${pairs.length} ${entity} record permission flags, received ${allowed.length}`)
  }
  const permissions: Record<Key, boolean> = { ...none }
  pairs.forEach(([key], index) => {
    permissions[key] = allowed[index] === true
  })
  return permissions
}
